'use strict';

var R, lookupIntegrationParameter, pageKey, pageParam, pageURL, searchParam;

R = require('ramda');

pageURL = function pageURL() {
  var deep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var loc;
  loc = window.location.href;
  if (!deep) {
    return loc.replace('#' + window.location.hash, '');
  }
};

searchParam = function searchParam(search, paramName, defaultValue) {
  var finder, pair, toParam;
  if (!search) {
    return defaultValue;
  }
  finder = R.find(function (data) {
    return data[0] === paramName;
  });
  toParam = R.map(function (touple) {
    return touple.split(/=/);
  });
  pair = finder(toParam(search.split(/&/)));
  if (pair && pair[1] && pair[1].length > 0) {
    return decodeURIComponent(pair[1]);
  } else {
    return defaultValue;
  }
};

pageParam = function pageParam(paramName, defaultValue) {
  return searchParam(window.location.search.slice(1), paramName, defaultValue);
};

pageKey = function pageKey() {
  return 'path:' + window.location.pathname;
};

lookupIntegrationParameter = function lookupIntegrationParameter(callbackName) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return function () {
    var res;
    res = defaultValue;
    if (window[callbackName] && typeof window[callbackName] === 'function') {
      for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      res = window[callbackName].apply(this, params);
    }
    return res;
  };
};

module.exports = {
  pageURL: pageURL,
  pageKey: pageKey,
  pageParam: pageParam,
  searchParam: searchParam,
  tracking: lookupIntegrationParameter('_zuppler_get_tracking_code'),
  navigate: function navigate(url) {
    return window.location.href = url;
  }
};